module.exports = __webpack_public_path__ + "static/media/img_location_slc.9ba5e29a.jpg";